export interface StripeLegacyCheckoutType {
    configure: (input: {
        closed: () => void;
        currency: string;
        description: string;
        key: string;
        locale: string;
        name: string;
        opened: () => void;
        token: (token: StripeLegacyToken) => void;
    }) => StripeLegacyHandlerType;
}

export interface StripeLegacyToken {
    id: string;
}

interface StripeLegacyHandlerType {
    open: (input: {amount: number}) => void;
}

const DummyStripeLegacyCheckout: StripeLegacyCheckoutType = {
    configure: ({closed, opened, token}) => {
        setTimeout(() => {
            opened();
            setTimeout(() => {
                token({id: 'dummy_id'});
                closed();
            }, 2000);
        }, 2000);

        return {
            open: () => {},
        };
    },
};

// Using Hat's Stripe (Legacy) functionality
const getStripeLegacyCheckout = () => {
    if (import.meta.env.STORYBOOK === 'true') return DummyStripeLegacyCheckout;
    if (import.meta.env.DEV === 'true') return DummyStripeLegacyCheckout;
    if (import.meta.env.VITEST === 'true') return DummyStripeLegacyCheckout;

    if (window.StripeCheckout) {
        return window.StripeCheckout;
    }

    return null;
};

export default getStripeLegacyCheckout;
